import request from './request'
import { QueryPageDto, QueryMonthDto, QueryDateSlotDto } from './dto'
interface GetDto extends QueryPageDto, QueryDateSlotDto {
}
export interface ContractRecordDto {
    id: number
    companyId: number
    companyName: string
    serveCompanyName: string
    projectId: number
    userId: number
    userName: string
    idCardNo: string
    flowId: string
    flowName: string // 合同名称
    createOn: string // 发起时间
    deadline: string // 截止时间
    signingTime: string
    labourCost: string // 工价
    flowStatus: string // 签署状态,INIT=待签署,PART=待签署,REJECT=已拒签,CANCEL=已撤销,DEADLINE=已过期,ALL=已签署
    isSuccess: string // 是否签署 1:已签署,0:未签署
    flowMessage: string // 签署信息
    isDelete: number
}
export interface BatchActionsDto {
    ids: number[]
    flowMessage: string
}
// 获取合同列表
export function getContractRecord(params: GetDto): Promise<{ total: number, list: ContractRecordDto[] }> {
    return request.get('/rest/elesign/ele-sign-contract-record/list', {
        params
    })
}

// 获取合同模板列表
export function getContractTempletes(params: GetDto): Promise<{ total: number, list: ContractRecordDto[] }> {
    return request.get('/rest/elesign/ele-sign-contract-template/list', {
        params
    })
}

export function openContract(): Promise<{ consoleUrl: string }> {
    return request.get('/api/v1/ele-sign/company-open')
}

// 修改合同年限
export function setContractYear(data: { id: number, effectiveTime: number, unit: number }): Promise<void> {
    return request.put('/rest/elesign/ele-sign-contract-template', data)
}

// 查看合同详情
export function openContractDetail(flowId: string): Promise<{ consoleUrl: string }> {
    return request.get(`/rest/elesign/ele-sign-contract-record/view/${flowId}/contract`)
}

//下载合同
export function downloadSignRecordPdfForFlows(ids: Array<number>): Promise<any> {
    return request.post('/rest/elesign/ele-sign-contract-record/download-sign-record-pdf-for-flows', { ids })
}

//电子签充值记录
export function eleRechargeRecord(params: GetDto): Promise<{ total: number, list: ContractRecordDto[] }> {
    return request.get('/rest/elesign/ele-sign-contract-record/elesign-recharge-record', {
        params
    })
}

// 取消签署接口 状态为流签、撤回或拒签的记录可以取消
export function rescindSignContract(data: { id: number }): Promise<void> {
    return request.put('/rest/elesign/ele-sign-contract-record/cancel', data)
}

// 批量取消签署接口，适用于状态为流签、撤回和拒签的记录
export function batchRescindSignContract(data: { ids: number[] }): Promise<void> {
    return request.put('/rest/elesign/ele-sign-contract-record/batchCancel', data)
}

// 撤销合同记录的操作
export function revokeContract(data: { id: number; flowMessage: string }): Promise<void> {
    return request.put('/rest/elesign/ele-sign-contract-record/revoke', data)
}

// 批量撤销合同记录的操作
export function batchRevokeContract(data: BatchActionsDto): Promise<void> {
    return request.put('/rest/elesign/ele-sign-contract-record/batchRevoke', data)
}

// 发起解除协议的操作
export function createReleaseFlow(data: { id: number; flowMessage: string }): Promise<void> {
    return request.put('/rest/elesign/ele-sign-contract-record/createReleaseFlow', data)
}

// 批量发起解除协议
export function createReleaseFlowBatch(data: { ids: number[]; flowMessage: string }): Promise<void> {
    return request.put('/rest/elesign/ele-sign-contract-record/batchCreateReleaseFlow', data)
}
